import React from 'react';
import PropTypes from 'prop-types';
import classes from '../addScripts.module.scss';
import Select from '../../../../_common/Form/Selects/Select/Select';
import InputField from '../../../../_common/Form/TextFields/InputField';
import DOBPicker from '../../../../_common/Form/DatePickers/DOBPicker/DOBPicker';

const priorAuthOptions = [
  'Approved',
  'Denied',
  'Payor Restriction',
  'Limited Distribution',
];

const PriorAuthorization = ({
  priorAuthInfo: {
    priorAuth, transNPI, location, transDate,
  },
  setPriorAuth, error,
}) => (
  <div className={classes.authorization_wrapper}>
    <h4>Prior Authorization</h4>

    <div className={classes.fields_block}>
      <div className={classes.fields_left_block}>
        <Select
          label="Status"
          onChange={(option) => setPriorAuth('priorAuth', option)}
          currentOption={priorAuth}
          options={priorAuthOptions}
        />

        <InputField
          label="Transfer Pharmacy NPI"
          value={transNPI}
          onChange={(value) => setPriorAuth('transNPI', value)}
        />
      </div>

      <div className={classes.fields_right_block}>
        <InputField
          label="Location"
          value={location}
          onChange={(value) => setPriorAuth('location', value)}
        />

        <DOBPicker
          label="Transfer Pharmacy Date"
          date={transDate}
          dateFormat="YYYY-MM-DD"
          onChange={(date) => setPriorAuth('transDate', date)}
          autoValidation={false}
          error={error}
        />
      </div>
    </div>
  </div>
);

PriorAuthorization.propTypes = {
  priorAuthInfo: PropTypes.object.isRequired,
  setPriorAuth: PropTypes.func.isRequired,
  error: PropTypes.string.isRequired,
};

export default PriorAuthorization;
